const normalizePrices = (data) => data;

export default normalizePrices;
